export const timeConversion = (utcDateTimeStamp, timeZone = 'Europe/London') =>
	(new Date(utcDateTimeStamp)).toLocaleTimeString('en-GB', {
		timeZone: timeZone,
		timeStyle: 'short'
	});
